import RichText from './versions/0.0.1';

export default RichText;
